//File
export const GET_FILES = '/file/';
export const GET_FILES_QUERY = '/file/query';
export const GET_ONE_FILE = '/file/';
export const UPDATE_FILE = '/file/';
export const UPDATE_FILE_FAVOURITES = '/file/favourites/';
export const DELETE_FILE = '/file';

//Folder
export const GET_FOLDERS = '/folder/';
export const GET_ONE_FOLDER = '/folder/';
export const GET_FOLDER_STRUCTURE = '/folder/folder-structure';
export const ADD_FOLDER = '/folder/';
export const UPDATE_FOLDER = '/folder/';
export const DELETE_FOLDER = '/folder/';

//Upload
export const UPLOAD_FILES = '/upload';
export const UPLOAD_FILE = '/upload/file';
export const UPLOAD_IMAGE = '/upload/image';
export const UPLOAD_FOLDERS_FILE = '/upload/folders/file';

//Download
export const DOWNLOAD_FILE = '/download';
export const DOWNLOAD_IMAGE_BASE64 = '/download/image';
export const DOWNLOAD_IMAGE_SAS_TOKEN = '/download/image/sas/token';

//File Type
export const GET_FILE_TYPE = '/file/type/';
export const GET_FILE_TYPE_BY_CODE = '/file/type/code/';